import { api } from '@epcbuilder/lib/utils';
import { RegisterWithAddress } from '@/models/generic';

export const postRegisterWithAddress = async (data: RegisterWithAddress) => {
  await api.post('/auth/register-user-and-property', data);
};
